import { render, staticRenderFns } from "./CommentManage.vue?vue&type=template&id=68788163&scoped=true"
import script from "./CommentManage.vue?vue&type=script&lang=js"
export * from "./CommentManage.vue?vue&type=script&lang=js"
import style0 from "./CommentManage.vue?vue&type=style&index=0&id=68788163&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68788163",
  null
  
)

export default component.exports